<template>
<div class="mt-5">
     <h1 class="sleep relate mx-auto ">Related most Review<br> Product</h1>
</div>
</template>

<script>

export default {
  data () {
    return {
      
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/page3/review.vue